import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MicIcon from '../../../../images/vector/mic.svg';
import CheckmarkOutline from '../../../../images/vector/checkmark-outline.svg';
import AudioView from '../../../audio/TRCAudioView';
import successSound from '../../../../sounds/success_sound.mp3';

export const MIC_PERMISSIONS_TEST_SUCCESS_TIMEOUT = 1500;
// Minimum display time to ensure checkmark is visible even if audio fails to load
const MIN_DISPLAY_TIME = 500;

class MicPermissionsTestSuccessCard extends Component {
    constructor(props) {
        super(props);
        this.onDoneTimerId = null;
        this.state = {
            isAudioReadyToPlay: false,
        };
        this.mountTime = null;
    }

    componentDidMount() {
        this.mountTime = Date.now();
        this.onRender();
        // Safety fallback: if audio callback never fires (e.g., audio fails to load),
        // still transition after a reasonable time
        this.safetyTimeoutId = setTimeout(() => {
            if (!this.transitionCalled) {
                this.transitionCalled = true;
                this.props.onDone();
            }
        }, MIC_PERMISSIONS_TEST_SUCCESS_TIMEOUT + 1000); // Extra buffer beyond expected duration
    }

    componentWillUnmount() {
        clearTimeout(this.onDoneTimerId);
        clearTimeout(this.safetyTimeoutId);
    }

    onRender = () => this.setState({ isAudioReadyToPlay: true });

    handleAudioComplete = () => {
        // Prevent multiple calls to onDone
        if (this.transitionCalled) {
            return;
        }

        clearTimeout(this.safetyTimeoutId);

        // Ensure minimum display time for checkmark visibility
        const elapsedTime = Date.now() - this.mountTime;
        const remainingTime = Math.max(0, MIN_DISPLAY_TIME - elapsedTime);

        clearTimeout(this.onDoneTimerId);
        this.onDoneTimerId = setTimeout(() => {
            this.transitionCalled = true;
            this.props.onDone();
        }, remainingTime);
    };

    render() {
        return (
            <div className="mic-success-card">
                <div className="instruction-content">
                    <MicIcon />
                    {this.props.text}
                </div>
                <CheckmarkOutline />
                <AudioView
                    audioTracks={[successSound]}
                    isReadyToPlay={this.state.isAudioReadyToPlay}
                    onEndCallback={this.handleAudioComplete}
                />
            </div>
        );
    }
}

MicPermissionsTestSuccessCard.propTypes = {
    text: PropTypes.string.isRequired,
    onDone: PropTypes.func.isRequired,
};

export default MicPermissionsTestSuccessCard;
